import Options from './c-icon';

export default Options;